// eslint-disable-next-line import/prefer-default-export
export const TYPE_TRANSFERT_PRET = 18;
